import Vue from 'vue'
import Vuex from 'vuex';
import { getAdminId } from "@/utils/localStorage.js";
import { getWebsocket } from "@/config";

Vue.use(Vuex);
const store = new Vuex.Store({
    state :{
        data:{
            id:""
        },
        websock:null,
        websockData: [],
        notice:{},
    },
    mutations :{
        getGiftInfo(state, data){
            state.data.id = data.id
        },
        getAdminId(state, id){
            state.admin_id = id
        },
        STAFF_UPDATEWEBSOCKET(state, websock) {
            state.websock = websock
          },
        STAFF_SEDNWEBSOCKET(state, item) {
            state.websock.send(JSON.stringify(item));
        },
        getNotice(state, data){
            state.notice = data;
        },
    },
    actions: {
        STAFF_WEBSOCKET({ commit }) {
            commit('STAFF_UPDATEWEBSOCKET', new WebSocket(getWebsocket()))
            // 只有定义了onopen方法，才能继续实现接收消息，即在使用的地方调用onmessage方法。
            store.state.websock.onopen = function() {
              var data = {
                action:"login",
                admin_id:"",
              }
              data.admin_id = getAdminId();
              store.state.websock.send(JSON.stringify(data))
            }
            // 获取数据
            store.state.websock.onmessage = function(e) {
                let data = [];
                const redata = JSON.parse(e.data)
                data.push(redata)
                store.state.websockData = data;
              }
        },
}
})
export default store

